<div class="screen-title">
    Add a new customer contact
</div>

<contact-edit [model]="model | async" [isNew]="isNew" [showAlert]="showAlert" (onSave)="saveContact($event)" (onCancel)="cancel()" (goToContact)="goToContact()"></contact-edit>
